import Category from "@/components/templates/Category";
import Account from "./Account";
import Homepage from "./Homepage";
import Login from "./Login";
import Product from "./Product";
import Table from "@/components/templates/Table";
import InspirationCategory from "@/components/templates/InspirationCategory";
import ArchiveTables from "@/components/templates/ArchiveTables";
import Aboutpage from "@/components/templates/About";
import Page from "@/components/templates/Page";
import Inspirations from "@/components/templates/Inspirations";
import Faqs from "@/components/templates/Faqs";
import Cart from "@/components/templates/Cart";
import ArchiveTag from "@/components/templates/ArchiveTag";
import Catalogue from "@/components/templates/Catalogue";
import Checkout from "@/components/templates/Checkout";
import ResultsPage from "@/components/templates/ResultsPage";
import Contact from "@/components/templates/Contact";
import GoogleRedirect from "@/components/templates/GoogleRedirect";
import Signup from "@/components/templates/Signup";
import ResetPassword from "@/components/templates/ForgotPassword/reset-password";
import ForgotPassword from "@/components/templates/ForgotPassword/index";
import Inspiration from "@/components/templates/Inspiration";

export const templates: {
  [key: string]: Template;
} = {
  categories: Category,
  default: Page,
  product: Product,
  homepage: Homepage,
  account: Account,
  login: Login,
  tables: Table,
  inspiration_category: InspirationCategory,
  inspiration_archive: Inspirations,
  single_inspiration: Inspiration,
  "archive-tables": ArchiveTables,
  about: Aboutpage,
  faq: Faqs,
  cart: Cart,
  tag: ArchiveTag,
  catalogue: Catalogue,
  checkout: Checkout,
  search: ResultsPage,
  contact: Contact,
  "google-callback": GoogleRedirect,
  signup: Signup,
  "forgot-password": ForgotPassword,
  "reset-password": ResetPassword,
};
